export const searchHousing = (data, value) => {
  const regex = new RegExp(`${value}[а-яё]*`, "iu");
  return data.filter((item) => regex.test(item.housingName));
};
